import { css } from '@emotion/core'
import { mediumUp, largeUp } from 'Utils'
import theme from 'Theme'

const { spacing, mixins } = theme

export default () => css`
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr;
  grid-gap: ${spacing.base_2}px;

  @media ${mediumUp} {
    grid-template-rows: 1fr 1fr;
    grid-template-columns: 1fr 1fr;
  }

  @media ${largeUp} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr;
  }

  .card--loading {
    min-height: 350px;
    ${mixins.loadingLight(theme)}
  }
`
